import React from 'react';

const Footer = () => {
    return (
        <div className='bg-gray-100 border border-gray-200 py-2 text-gray-800 font-poppins text-center'>
            <p>&copy;2023 FreJun | Developed By <span className='text-actionbtn'><a href='https://saadhossain.dev/'>Saddam Hossain</a></span></p>
        </div>
    );
};

export default Footer;